import GoogleReviewsBadge from './GoogleReviewsBadge';

export default GoogleReviewsBadge;
